import { render, staticRenderFns } from "./GenericPermissions.vue?vue&type=template&id=931f4be0"
import script from "./GenericPermissions.vue?vue&type=script&lang=js"
export * from "./GenericPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports